import { Box } from "@mui/material";
import styled, { css } from "styled-components";
import { grey } from "@mui/material/colors";

export const EditStyleWrapper = styled(Box)<{ $canEdit: boolean; $isActive: boolean | undefined }>`
	position: relative;
	//padding: 2px;
	display: flex;
	justify-content: center;

	&::after {
		content: "";
		position: absolute;
		top: -5px;
		left: -4px;
		width: calc(100% + 8px);
		right: -4px;
		bottom: -5px;
		border: 2px dashed ${grey[600]};
		pointer-events: none;
		opacity: 0;
		transition: opacity 0.2s ease;
		box-sizing: border-box;
		border-radius: 10px;
		z-index: 100;
		${({ $isActive }) =>
			$isActive
				? css`
						opacity: 1;
					`
				: css`
						opacity: 0;
					`}
	}

	&:hover::after {
		opacity: ${({ $canEdit }) => ($canEdit ? 1 : 0)};
	}

	&:hover {
		cursor: ${({ $canEdit }) => ($canEdit ? "pointer" : "unset")};
	}

	&:hover .editIcon {
		opacity: ${({ $canEdit }) => ($canEdit ? 1 : 0)};
	}

	.editIcon {
		position: absolute;
		top: -12px;
		right: -12px;
		fill: ${grey[400]};
		opacity: 0;
		width: 20px;
		z-index: 10;
	}
`;
